import React, { createContext, useState } from 'react';

export const MsalTokenContext = createContext(undefined);

const MsalTokenProvider = ({ children }) => {
    const [accessToken, setAccessToken] = useState(null);

    const updateAccessToken = (token) => {
        setAccessToken(token);
    };

    return (
        <MsalTokenContext.Provider value={{ accessToken, updateAccessToken }}>
            {children}
        </MsalTokenContext.Provider>
    );
};

export default MsalTokenProvider;
